module.exports = __webpack_public_path__ + "img/avatar-4.7fa76669.png";